import { Fragment, useRef, useState } from 'react'
import { EnhancedPaper } from 'summon-ui'
import { useTranslation } from 'summon-ui/intl'
import { Title, Flex, Paper, Stack, Text, Box, Button, Divider, Group } from 'summon-ui/mantine'
import { TENANT_ONBOARDING } from '@config'
import useOnboardingUtils from '@features/onboarding/hooks/useOnboardingUtils'
import { useViewer } from '@hooks'
import useAvatarDownloader from '@hooks/useAvatarDownloader'
import AvatarPreview from '@modules/avatar'
import OnboardingHeader from '../components/OnboardingHeader'
import { useOnboardingStorage } from '../onboarding.store'

const CARDS_DATA = [
  {
    name: 'Discover Quests',
    description: 'Find ways to contribute your skills'
  },
  {
    name: 'Engage In Proposals',
    description: 'Have your voice heard'
  },
  {
    name: 'Earn Rewards',
    description: 'Complete tasks, earn XP, and level up'
  },
  {
    name: 'Customize Your Avatar',
    description: 'Personalize your avatar with unique, rare collectibles'
  }
]

const DiscoverView = () => {
  const t = useTranslation()
  const { viewer, isLoading: isViewerLoading } = useViewer()
  const { previousStep } = useOnboardingStorage()
  const [loading, setLoading] = useState(false)
  const { uploadAvatar, loading: submittingImage } = useAvatarDownloader()
  const { completeOnboarding } = useOnboardingUtils()

  const canvas = useRef<HTMLCanvasElement>(null)
  const submitUser = async () => {
    try {
      setLoading(true)
      await uploadAvatar(canvas.current)
      await completeOnboarding({})
    } catch (error) {
      console.error('Error completing onboarding', error)
    } finally {
      setLoading(false)
    }
  }

  const dataList = () => (
    <Flex h='100%' align='center'>
      <Paper p='xl' bg='transparent' radius='md' withBorder mah={500}>
        <Stack justify='center'>
          <Title order={2}>Things to do:</Title>
          {CARDS_DATA.map((item, index) => (
            <Fragment key={item.name}>
              <Box key={item.name}>
                <Title order={4} fw={700}>
                  {index + 1}. {item.name}
                </Title>
                <Text>{item.description}</Text>
              </Box>
              {index === CARDS_DATA.length - 1 ? null : <Divider />}
            </Fragment>
          ))}
        </Stack>
      </Paper>
    </Flex>
  )

  return (
    <div className='w-full h-full'>
      <OnboardingHeader title='Welcome' subTitle={TENANT_ONBOARDING.welcome.subtitle} />
      <div className='flex w-full flex-col gap-4 md:h-[70%] md:flex-row'>
        <div className='w-full md:w-1/2'>{!isViewerLoading && <AvatarPreview isDNATraits ref={canvas} />}</div>
        {dataList()}
      </div>
      <EnhancedPaper withBg w='100%' className='md:absolute fixed bottom-0 left-0'>
        <Divider mb='md' />
        <Group justify='space-between' px='sm' mb='md'>
          <Button variant='outline' onClick={previousStep} disabled={!!viewer?.skinId} miw={100}>
            {t('Back')}
          </Button>
          <Button onClick={submitUser} loading={submittingImage || loading} miw={100}>
            {t('Get Started')}
          </Button>
        </Group>
      </EnhancedPaper>
    </div>
  )
}

export default DiscoverView
